import Form from './Profile/Form';
import ImageUpload from './Profile/ImageUpload';
import Main from './Profile/Main';

import GroupCard from './Follows/GroupCard';
import UserCard from './Follows/UserCard';

export { Form, ImageUpload, Main, GroupCard, UserCard };
